import React from 'react'
import { BonusesData } from '../constant/data'
const Bonuses = () => {
    return (
        <div className='bg-[#012a47] pb-40'>
            <div className='max-w-5xl mx-auto '>

                <div className='text-white text-center '>
                    <div className='flex flex-col justify-center items-center gap-6'>
                        <h2 className='text-[45px] leading-[3.5rem] font-bold'>Here's Your Free Bonus Gifts:
                        </h2>
                        <p className='text-2xl font-light'>
                            Included with your order are the following bonus products.
                        </p>
                        <p className='text-2xl font-light'>
                            Please follow the instructions below to download your FREE eBooks and start using the valuable information from today:
                        </p>
                    </div>

                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 p-4 gap-6">
                    {BonusesData.map((item) => (
                        <div key={item.id} className="space-y-3 flex flex-col items-center">
                            <img src={item.image} alt={item.alt} className="md:w-2/3 h-96 object-contain" />
                            <button
                                onClick={() => window.open(item.link, '_blank')} // Open the link in a new tab
                                className="bg-[#FDC054]  rounded-lg shadow-md flex items-center gap-3 px-10 py-3 font-bold text-base"
                            >
                                Download Now
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    className="size-5"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                                    />
                                </svg>
                            </button>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    )
}
export default Bonuses
